export default __webpack_public_path__ + "static/media/jacket-1.87c2a998.jpg";